var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class WyreStormSw740Tx {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'GET MP all',
                next: /MP .+ all/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET STANDBY`, /STANDBY (on|off)/i, tags);
                return match[1].toLowerCase() === 'off';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SET STANDBY ${power ? 'off' : 'on'}`, /STANDBY (on|off)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 6500 : 2000);
                return match[1].toLowerCase() === 'off';
            }),
            asyncHandlers: [
                {
                    regExp: /STANDBY (on|off)/i,
                    callback: (match) => {
                        const power = match[1].toLowerCase() === 'off';
                        this.state.power.update(power);
                    },
                },
            ],
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET MP all`, /MP (.+) all$|No active source channel/i, tags);
                if (match[1])
                    return match[1].toLowerCase();
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SET SW ${value} all`, /SW (.+) all$|SW .+ Failed|parameter error/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 3000);
                if (match[1])
                    return match[1].toLowerCase();
                return this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    regExp: /SW (.+) all$/i,
                    callback: (match) => {
                        const value = match[1].toLowerCase();
                        this.state.videoMatrixRoutes.update('1', value);
                    },
                },
            ],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET VOLUME`, /VOLUME (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SET VOLUME ${volume}`, /VOLUME (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            asyncHandlers: [
                {
                    regExp: /VOLUME (\d+)/i,
                    callback: (match) => {
                        const volume = parseInt(match[1], 10);
                        this.state.volume.update(volume);
                    },
                },
            ],
            range: { max: 100, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET AUDOUT_MUTE`, /AUDOUT_MUTE (.+)/i, tags);
                return match[1] === 'on';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SET AUDOUT_MUTE ${mute ? 'on' : 'off'}`, /AUDOUT_MUTE (.+)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 3000);
                return match[1] === 'on';
            }),
            asyncHandlers: [
                {
                    regExp: /AUDOUT_MUTE (.+)/i,
                    callback: (match) => {
                        const mute = match[1] === 'on';
                        this.state.volumeMute.update(mute);
                    },
                },
            ],
        };
        // polling
        this.polls = [
            { intervalMs: 4000, controls: ['power', 'videoMatrixRoutes'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            // Configure auto switching.
            yield this.socket.sendAsync(`SET AUTOSW_FN ${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? 'on' : 'off'}`, ['configure']);
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
WyreStormSw740Tx.driverType = 'socketDriver';
WyreStormSw740Tx.key = '-Ms1RVBlDI_U_G8lbbzj';
WyreStormSw740Tx.baseSocketOptions = {};
WyreStormSw740Tx.socketOptions = [
    Object.assign(Object.assign({}, WyreStormSw740Tx.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, WyreStormSw740Tx.baseSocketOptions), { port: 4999 }),
];
